export const links = [
  {
    name: "Business Setup",
    submenu: true,
    sublinks: [
      {
        Head: "Startup",
        sublink: [
          { name: "Startup Recognition", link: "/commingSoon" },
          { name: "Business Plan", link: "/business-plan" },
          { name: "Startup Proposal", link: "/commingSoon" },
          { name: "Pitch Deck", link: "/pitch" },
          { name: "Fund Raising", link: "/fundraising" },
          { name: "Startup Schemes/grants", link: "/startup" },
          { name: "GeM Registration", link: "/gem-registration" },
        ],
      },
      {
        Head: "Business Incorporation",
        sublink: [
          { name: "Private Limited Company", link: "/private-company" },
          { name: "Limited Liability Partnership - LLP", link: "/llp" },
          { name: "One Person Company - OPC", link: "/one-person-company" },
          { name: "NIDHI Company", link: "/nidhi-company-registration" },
          { name: "Producer Company", link: "/producer" },
          { name: "Partnership Firm", link: "/commingSoon" },
          { name: "Sole Proprietorship", link: "/sole-proprietorship" },
        ],
      },
      {
        Head: "Business Registration & Licenses",
        sublink: [
          { name: "MSME Registration", link: "/msme" },
          { name: "Import Export Code [IEC]", link: "/iec-registration" },
          { name: "Shop Act License", link: "/shop" },
          { name: "GST Registration", link: "/gst" },
          { name: "PASARA License", link: "/psara" },
          { name: "APEDA License", link: "/apeda-license" },
          { name: "RERA Agent/Developer", link: "/rera" },
        ],
      },
      
      {
        Head: "Other Registrations",
        sublink: [
          { name: "ISO Certification", link: "/iso-certification" },
          { name: "DSC Token", link: "/dsc" },
          { name: "TAN Application", link: "/Tan" },
          { name: "PAN Application", link: "/pan-applicaton" },
          { name: "Drug License", link: "/drugLicense" },
          { name: "Barcode License", link: "/barcode" },
          { name: "RNI Registration", link: "/commingSoon" },
        ],
      },
      {
        Head: "Food Licenses",
        sublink: [
          { name: "FSSAI Registration", link: "/fssai-registration" },
          { name: "FSSAI State License", link: "/fssai-state" },
          { name: "FSSAI Central License", link: "/fssai-central" },
          { name: "FSSAI Renewal", link: "/commingSoon" },
          { name: "FSSAI Annual Return", link: "/fssai-annual" },
        ],
      },
    ],
  },
  {
    name: "NGO Management",
    submenu: true,
    sublinks: [
      {
        Head: "Registration",
        sublink: [
          { name: "Trust Registration", link: "/trust-registration" },
          { name: "Society Registration", link: "/society-registration" },
          { name: "Section 8 Company", link: "/section-8" },
          { name: "NGO Darpan Registration", link: "/ngo-darpan" },
        ],
      },
      {
        Head: "NGO Compliance",
        sublink: [
          { name: "12A & 80G Registration", link: "/ngo-registration" },
          { name: "FCRA Registration", link: "/fcraregistration" },
          { name: "CSR-1 Registration", link: "/csr1" },
          { name: "NGO Advocacy", link: "/ngo-advocacy" },
        ],
      },
      {
        Head: "Reports",
        sublink: [
          { name: "Annual Report", link: "/commingSoon" },
          { name: "Audit Report", link: "/commingSoon" },
          { name: "CSR Project Proposal", link: "/commingSoon" },
          { name: "Trust Change Report", link: "/commingSoon" },
        ],
      },
      {
        Head: "Funding",
        sublink: [
          { name: "Government Funding/Grants", link: "/commingSoon" },
          { name: "CSR Funding", link: "/commingSoon" },
          { name: "Foreign Funding", link: "/commingSoon" },
          { name: "Crowd Funding", link: "/commingSoon" },
        ],
      },
    ],
  },
  {
    name: "Trademark & IP",
    submenu: true,
    sublinks: [
      {
          sublink: [
          { name: "Trademark Registration", link: "/trademark-registration" },
          { name: "Patent Registration", link: "/patent-registration" },
          { name: "Copyright Registration", link: "/copyright" },
          { name: "Design Registration", link: "/design" },
        ],
      },
    ],
  },
  
];